import React, { useState } from 'react';
import flappycoins from "../assets/flappycoins.png";
import { FaAngleDown } from 'react-icons/fa';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`p-4 my-2 rounded ${isOpen ? 'bg-[#0052FF]' : 'bg-[#343944]'}`}
      onClick={() => setIsOpen(!isOpen)}
    >
        <div  className='flex items-center justify-between'>
      <h2 className="font-bold cursor-pointer">{question}</h2>
        <FaAngleDown/>
        </div>
      {isOpen && <p className="mt-2">{answer}</p>}
    </div>
  );
};

const FrequentQuestion = () => {
  const faqs = [
    {
      question: 'Your Question Here?',
      answer: 'The answer to the question will be displayed here.'
    },
    {
        question: 'Your Question Here?',
        answer: 'The answer to the question will be displayed here.'
      },
      {
        question: 'Your Question Here?',
        answer: 'The answer to the question will be displayed here.'
      },
      {
        question: 'Your Question Here?',
        answer: 'The answer to the question will be displayed here.'
      },
    // Add more FAQs here
  ];

  return (
    <>
     <div className='h-full md:w-[1442px] w-full flex items-center justify-center flex-col'>
      <section className='bg-black flex justify-center md:flex-row flex-col'>
        <article className='md:w-[50%] w-full flex px-10 mt-10 flex-col'>
          <h1 className='md:text-[4rem] text-[2rem]'>Frequently <span className='text-[#0052FF]'>Asked</span></h1>
          <h1 className='md:text-[4rem] text-[2rem]'>Questions</h1>
          <div className='mt-4'>
            {faqs.map((faq, index) => (
              <FAQItem key={index} question={faq.question} answer={faq.answer} />
            ))}
          </div>
        </article>
        <figure className='md:w-[50%] w-full flex items-center justify-center flex-col mt-5'>
          <img src={flappycoins} alt="Flappy Coins"/>
        </figure>
      </section>
      </div>
    </>
  );
};

export default FrequentQuestion;
